import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../Context/UserContext";
import toast from "react-hot-toast";
import { BaseURL } from "../../../Reusable/BaseURL";
import { Link, useNavigate } from "react-router-dom";
import CompareQuotationPageForm from "./CompareQuotationPageForm";
import { QuotationCompareIndentSelect } from "./QuotationCompareIndentSelect";

export default function CompareQuotation() {
  const { darkTheme, loginData, setIndentCreateItemId4Upd } =
    useContext(UserContext);

  const [indent, setIndent] = useState("");
  const [party, setParty] = useState("");
  const [negoAmountTotal, setNegoAmountTotal] = useState(0);
  const [getQuotationItem, setGetQuotationItem] = useState([
    // {
    //   quotation_item_id: null,
    //   indent_item_id: 19,
    //   division: "Kpk division 1",
    //   hsn_gst_percent: "12.00",
    //   hsn_no: "1120",
    //   item_code: "#KPK 1",
    //   item_name: "Kamleshwar 1",
    //   brand_name: null,
    //   unit: "Kpk UNIt 1",
    //   qty: "65",
    //   quoted_unit_rate: null,
    //   quoted_amount: null,
    //   discount: null,
    //   final_amount: null,
    //   negotiation_rate: null,
    //   negotiation_amount: null,
    // },
    // {
    //   quotation_item_id: null,
    //   indent_item_id: 27,
    //   division: "Kpk division 1",
    //   hsn_gst_percent: "12.00",
    //   hsn_no: "1120",
    //   item_code: "#KPK 1",
    //   item_name: "Kamleshwar 1",
    //   brand_name: null,
    //   unit: "Kpk UNIt 1",
    //   qty: "12",
    //   quoted_unit_rate: null,
    //   quoted_amount: null,
    //   discount: null,
    //   final_amount: null,
    //   negotiation_rate: null,
    //   negotiation_amount: null,
    // },
    // {
    //   quotation_item_id: null,
    //   indent_item_id: 27,
    //   division: "Kpk division 1",
    //   hsn_gst_percent: "12.00",
    //   hsn_no: "1120",
    //   item_code: "#KPK 1",
    //   item_name: "Kamleshwar 1",
    //   brand_name: null,
    //   unit: "Kpk UNIt 1",
    //   qty: "12",
    //   quoted_unit_rate: null,
    //   quoted_amount: null,
    //   discount: null,
    //   final_amount: null,
    //   negotiation_rate: null,
    //   negotiation_amount: null,
    // },
  ]);

  const [links, setLinks] = useState([]);
  const [firstPage, setFirstPage] = useState([]);
  const [totalNo, setTotalNo] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(false);

  const [addMoreToggle, setAddMoreToggle] = useState(false);
  const [changingSelect, setChangingSelect] = useState(false);

  const [submitAction, setSubmitAction] = useState("submit");

  const navigate = useNavigate();

  const getQuotation = async (indentId) => {
    setGetQuotationItem([]);
    setSpinner(true);
    const response = await fetch(
      `${BaseURL}/purchase/comparestatement?indent_id=${indentId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${loginData.token}`,
        },
      }
    );
    const data = await response.json();
    if (data.status) {
      setGetQuotationItem(data.data);
      setSpinner(false);
    }
    if (data.status === false) {
      toast.error("Indent Required");
      setSpinner(false);
    }else{
      setSpinner(false)
    }
  };

  // create
  async function submitQuotationItems(e) {
    e.preventDefault();

    const formData = {
      indent_id: indent.value,
      party_id: party.value,
      quotations: getQuotationItem,
      quotation_sum_amount: negoAmountTotal,
    };
    console.log({ quotations: formData });

    const res = await fetch(`${BaseURL}/purchase/quotation/save`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          // getUnsavedItemList();
          toast.success("Success");
          setGetQuotationItem([]);
          setParty("");
          // setIndent("");
        }
        if (createRes.status === false) {
          toast.error("Submition error");
        }
        // if (createRes?.error?.message.date) {
        //   toast.error(createRes.error.message.date);
        // } else if (createRes?.error?.message.severity) {
        //   toast.error(createRes.error.message.severity);
        // }
      });
  }

  // Listing record
  function firstPageList(url = `${BaseURL}/states?page=1`) {
    setSpinner(true);
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((li) => {
        if (li?.status) {
          const revData = li.data.data.reverse();
          setFirstPage(revData);
          setTotalNo(li.data.total);
          setFrom(li.data.from);
          setTo(li.data.to);
          setLinks(li.data.links);
          setSpinner(false);
        }
      });
  }

  function editBtn(id) {
    fetch(`${BaseURL}/purchase/indent/getcacheitem/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((selectedRecord) => {
        if (selectedRecord.status) {
          setChangingSelect(true);
          setSubmitAction("update");

          // setDivision(selectedRecord.data.division || "");
        }
      });
    setChangingSelect(false);
  }

  function cancelUpdate() {
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setSubmitAction("submit");
    setGetQuotationItem([]);
    setParty("");
    setIndent("");
  }
  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-2 rounded-tr-lg rounded-tl-lg ${
              darkTheme ? "border-b-slate-700" : "border-b-slate-200"
            }`}
          >
            Quotation Compare
          </div>
          <div
            // className="grid grid-cols-1 gap-8 md:gap-1 lg:gap-4 md:grid-cols-2"
            className="flex flex-col gap-3 md:gap-1 lg:gap-4"
          >
            <div className="px-2 mb-6 flex w-full flex-wrap">
              <form>
                <div className="flex flex-wrap gap-x-2 md:gap-x-6 gap-y-2">
                  <div className="mb-2 min-w-[260px] max-w-[460px]">
                    <label>Indent <span className="text-red-500 font-bold">*</span></label>
                    <QuotationCompareIndentSelect
                      selectedOption={indent}
                      setSelectedOption={setIndent}
                      changingSelect={changingSelect}
                      cancelUpdate={cancelUpdate}
                      setGetQuotationItem={setGetQuotationItem}
                      getQuotationItem={getQuotationItem}
                      setParty={setParty}
                      party={party}
                    />
                  </div>
                </div>
              </form>
              <div>
                <button
                  onClick={() => getQuotation(indent.value)}
                  className="bg-green-600 rounded-md px-4 py-2 text-white mt-5 ml-3"
                >
                  Compare
                </button>
              </div>
            </div>

            <div className="w-full px-2">
              <CompareQuotationPageForm
                editBtn={editBtn}
                // firstPageList={firstPageList}
                links={links}
                firstPage={getQuotationItem}
                setFirstPage={setGetQuotationItem}
                setGetId={setGetId}
                spinner={spinner}
                totalNo={totalNo}
                from={from}
                to={to}
                addMoreToggle={addMoreToggle}
                setAddMoreToggle={setAddMoreToggle}
                negoAmountTotal={negoAmountTotal}
                setNegoAmountTotal={setNegoAmountTotal}
              />
            </div>

            {/* {submitAction === "submit" && (
              <div className="flex items-center justify-center gap-x-1 mt-2">
                <Button type="submit" 
                onClick={(e) => submitQuotationItems(e)}
                  >
                  Send
                </Button>
                <Button type="button" onClick={() => cancelUpdate()}>
                  Clear
                </Button>
              </div>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
}
